/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Planner_Sessions_ValueInputs */

const en_planner_sessions_value = /** @type {(inputs: Planner_Sessions_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ×`)
};

const de_planner_sessions_value = /** @type {(inputs: Planner_Sessions_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ×`)
};

/**
* | output |
* | --- |
* | "{count} ×" |
*
* @param {Planner_Sessions_ValueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const planner_sessions_value = /** @type {((inputs: Planner_Sessions_ValueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planner_Sessions_ValueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_planner_sessions_value(inputs)
	return en_planner_sessions_value(inputs)
});